<template>
  <div :class="$style.filterBar">
    <el-select v-model="localFilters.type" clearable :placeholder="placeholders.type" size="small" :class="$style.filterItem" @change="emitChange">
      <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>

    <el-select v-model="localFilters.operator" clearable :placeholder="placeholders.operator" size="small" :class="$style.filterItem" @change="emitChange">
      <el-option v-for="item in operatorOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>

    <el-select v-model="localFilters.periodStatus" clearable :placeholder="placeholders.periodStatus" size="small" :class="$style.filterItem" @change="emitChange">
      <el-option v-for="item in periodStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>

    <el-select v-model="localFilters.state" clearable :placeholder="placeholders.state" size="small" :class="$style.filterItem" @change="emitChange">
      <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'PriceAdjustmentFilters',
  props: {
    filters: {
      type: Object,
      default: () => ({ type: '', operator: '', periodStatus: '', state: '' }),
    },
    typeOptions: {
      type: Array,
      default: () => [],
    },
    operatorOptions: {
      type: Array,
      default: () => [],
    },
    periodStatusOptions: {
      type: Array,
      default: () => [],
    },
    stateOptions: {
      type: Array,
      default: () => [],
    },
    placeholders: {
      type: Object,
      default: () => ({
        type: '類型篩選',
        operator: '金額調整篩選',
        periodStatus: '期間狀態篩選',
        state: '啟用篩選',
      }),
    },
  },
  data() {
    return {
      localFilters: {
        type: '',
        operator: '',
        periodStatus: '',
        state: '',
      },
    }
  },
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler(value) {
        this.localFilters = {
          type: value?.type || '',
          operator: value?.operator || '',
          periodStatus: value?.periodStatus || '',
          state: value?.state === '' || value?.state === 0 || value?.state === 1 ? value.state : '',
        }
      },
    },
  },
  methods: {
    emitChange() {
      this.$emit('change', { ...this.localFilters })
    },
  },
}
</script>

<style lang="scss" module scoped>
.filterBar {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.filterItem {
  width: 180px;
}
</style>
